export default "__VITE_ASSET__CARuRxKi__"